import { render, staticRenderFns } from "./CodeAllot.vue?vue&type=template&id=5bb11ca0&scoped=true"
import script from "./CodeAllot.vue?vue&type=script&lang=js"
export * from "./CodeAllot.vue?vue&type=script&lang=js"
import style0 from "./CodeAllot.vue?vue&type=style&index=0&id=5bb11ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb11ca0",
  null
  
)

export default component.exports